{
  "intro": "The project's public addresses, which make servers reachable from the internet. An address belongs to the project, not to a server: you can move it to another server of the same region and keep it after a server is deleted. IPv4 is billed every month, even when unassigned; IPv6 is free.",
  "empty": "No public addresses yet",
  "emptyLead": "Addresses arrive with servers. Create one in advance when it must outlive a server, for example so DNS records stay the same when a server is rebuilt.",
  "create": "Create IP address",
  "createLead": "A new address in a region, or straight on a powered-off server.",
  "createSubmit": "Create address",
  "created": "Address {{address}} created",
  "name": "Name",
  "nameHint": "To recognise the address in the list, e.g. by the site it serves.",
  "family": "Type",
  "ipv4Price": "{{price}} per month. Most services need one.",
  "ipv4Paid": "Billed monthly.",
  "ipv6Free": "A /64 network, free.",
  "where": "Where",
  "keepFree": "Keep it free in a region",
  "onServer": "Assign it to a server now",
  "zone": "Network zone {{zone}}",
  "regionHint": "The address can be assigned only to servers of this region.",
  "server": "Server",
  "chooseServer": "Choose a server",
  "offOnly": "Hetzner changes primary addresses only while the server is off. A server has at most one IPv4 and one IPv6.",
  "autoDelete": "Deleted with server",
  "autoDeleteLabel": "Delete together with the server",
  "autoDeleteHint": "When on, the address goes away together with the server it is assigned to. Turn it off to keep the address after the server is deleted.",
  "autoDeleteOn": "Delete together with the server",
  "autoDeleteOff": "Keep after the server is deleted",
  "autoDeleteOnDone": "{{address}} will be deleted with its server",
  "autoDeleteOffDone": "{{address}} will be kept after its server is deleted",
  "billing": "IPv4 is billed from creation until deletion, assigned or not. IPv6 is free. A deleted address cannot be recovered: the next one will be different.",
  "address": "Address",
  "unassigned": "Unassigned",
  "serverOn": "Server is not off",
  "dnsShort": "Reverse DNS",
  "flags": "Properties",
  "protected": "Protected",
  "blocked": "Blocked",
  "price": "Per month",
  "free": "Free",
  "createdAt": "Created",
  "assign": "Assign to server",
  "assignTitle": "Assign {{address}} to a server",
  "assignLead": "The server must be off and in the same region. The change takes a few seconds.",
  "assigning": "Assigning {{address}}",
  "unassign": "Unassign from server",
  "unassigning": "Unassigning {{address}}",
  "dns": "Reverse DNS",
  "dnsTitle": "Reverse DNS of {{address}}",
  "dnsLead": "The name a lookup of the address returns (PTR record). Mail servers check it when they accept mail.",
  "dnsAddress": "Address inside the network",
  "dnsAddressHint": "Any address of {{network}}, e.g. the one configured on the server.",
  "dnsName": "Hostname",
  "dnsNameHint": "A full name such as mail.example.com. That name's forward record must point to this address.",
  "dnsWhy": "Reverse DNS turns an address into a name. Without it mail from the server lands in spam more often.",
  "dnsInvalid": "Enter a full hostname, e.g. mail.example.com.",
  "dnsReset": "Use the default",
  "dnsChanging": "Changing reverse DNS of {{address}}",
  "rename": "Rename",
  "protect": "Protect from deletion",
  "unprotect": "Remove deletion protection",
  "delete": "Delete",
  "deleteTitle": "Delete address {{address}}?",
  "deleteLost": "The address is lost for good: Hetzner gives it to someone else, and the next one you create is different.",
  "deleteDns": "DNS records pointing to this address stop working.",
  "deleteBilling": "Billing for the address stops.",
  "deleteFree": "IPv6 is free; deleting it saves no money.",
  "deleted": "Address {{address}} deleted",
  "why": {
    "assigned": "Assigned to {{server}}: unassign it first.",
    "notAssigned": "The address is not assigned.",
    "serverRunning": "{{server}} is not off: Hetzner unassigns addresses only from a powered-off server.",
    "blocked": "The provider blocked this address.",
    "protected": "Deletion protection is on: remove it first.",
    "deleteAssigned": "The address is assigned to a server: unassign it first.",
    "otherRegion": "other region",
    "hasAddress": "has {{family}} already",
    "running": "not off"
  }
}
